import Vue from 'vue'

// Auth
Vue.component('login-form', require('./components/Auth/Login').default);
Vue.component('register-form', require('./components/Auth/Register').default);

// Navbar
Vue.component('custom-navigation-menu', require('./components/Navbar'));

// Donations
Vue.component('nlcaa-donations', require('./components/Others/Donations').default);

// Quiz
Vue.component('quiz-app', require('./components/QuizApp/Index').default);
Vue.component('quiz-app-authentication-form', require('./components/QuizApp/Authentication').default);
Vue.component('quiz-app-authenticated-view', require('./components/QuizApp/AuthenticatedView').default);
Vue.component('quiz-app-questions-form', require('./components/QuizApp/QuestionForm').default);
Vue.component('quiz-app-question-answers', require('./components/QuizApp/Answers').default);

// Website
Vue.component('join-mailing-list', require('./components/MailingList').default);
Vue.component('testimonials', require('./components/Testimonials').default);
Vue.component('partner-logos', require('./components/PartnerLogos').default);
Vue.component('upcoming-events', require('./components/UpcomingEvents').default);
Vue.component('acceptance-testing-certification', require('./components/AcceptanceTestingCertifications').default);

// User Account
Vue.component('user-account-website', require('./components/Users/Account').default);
Vue.component('user-personal-info-website', require('./components/Users/PersonalInformation').default);
Vue.component('user-courses', require('./components/Dashboard/Users/Courses.vue').default);
Vue.component('user-schedules', require('./components/Dashboard/Users/Schedules.vue').default);

// Files
Vue.component('dropzone', require('./components/Files/Dropzone.vue').default);
Vue.component('model-files', require('./components/Files/Model.vue').default);
Vue.component('preview-file-modal', require('./components/Files/Preview.vue').default);
Vue.component('delete-file-modal', require('./components/Files/Delete.vue').default);
Vue.component('update-file-modal', require('./components/Files/Update.vue').default);

// Update Expired Application Documents
Vue.component('update-expired-document', require('./components/Applications/UpdateExpiredDocuments').default);

// Employer Applications
Vue.component('employer-application', require('./components/Applications/Employer/Employer'));
Vue.component('employer-agreement', require('./components/Applications/Employer/Agreement'));
Vue.component('employer-companies', require('./components/Applications/Employer/Companies').default);

// Technician Application
Vue.component('technician-application', require('./components/Applications/Technician/Technician'));
Vue.component('technician-companies', require('./components/Applications/Technician/Companies').default);

// Certified
// Vue.component('certified-table', require('./components/Certificates/Table').default);
Vue.component('technician-certificates', require('./components/Certificates/Technician').default);
Vue.component('employer-certificates', require('./components/Certificates/Employer').default);

// Calendar
Vue.component('schedule-calendar', require('./components/Calendar/Index').default);

// Courses
Vue.component('course-show', require('./components/Courses/Show'));
Vue.component('course-schedules', require('./components/Courses/Schedules').default);
Vue.component('course-notify-me-avilable', require('./components/Courses/NotifyMeAvailable').default);

// Schedules
Vue.component('schedule-status', require('./components/Dashboard/Schedules/Status.vue').default);

// Others
Vue.component('modal', require('./components/Others/Modal').default);
Vue.component('paginator', require('./components/Others/Paginator').default);
Vue.component('signature-pad', require('./components/Others/SignaturePad').default);
Vue.component('submit-button', require('./components/Others/SubmitButton').default);

// Forms
Vue.component('contact-us-form', require('./components/Forms/ContactUs').default);
Vue.component('complaints-and-suggestions-form', require('./components/Forms/ComplaintsAndSuggestions').default);
Vue.component('building-department-survey-form', require('./components/Forms/BuildingDepartmentSurvey').default);

// Payments
Vue.component('payment-form', require('./components/Payments/PaymentForm').default);
Vue.component('payment-form-modal', require('./components/Payments/PaymentFormModal').default);
